import { render, staticRenderFns } from "./profitdetail.vue?vue&type=template&id=61885440&scoped=true"
import script from "./profitdetail.vue?vue&type=script&lang=js"
export * from "./profitdetail.vue?vue&type=script&lang=js"
import style0 from "./profitdetail.vue?vue&type=style&index=0&id=61885440&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61885440",
  null
  
)

export default component.exports